import React, { FunctionComponent, useEffect, useState } from 'react'
// Disabling because getSize is required for component
// eslint-disable-next-line no-restricted-imports
import { Image } from 'react-native'

import styled from 'styled-components/native'

import { Image as ExpoImage } from '../image/Image'

import type { FullWidthImageProps } from './FullWidthImage'

/**
 * Web-only override of `FullWidthImage`. Resolved via `.web.tsx` extension
 * precedence in `apps/lyrahealthwebapp/webpack.common.js` (line ~257) and the
 * Storybook react-native-web vite plugin.
 *
 * Skips importing `react-native-svg`: on web, the browser renders SVG natively
 * via the `<img>` tag that `expo-image` produces. `Image.getSize` returns the
 * SVG's natural dimensions (or the 300×150 default if none are declared), so
 * raster and SVG share a single render path here.
 */
const DEFAULT_MAX_WIDTH = 1024

const ImageContainer = styled(ExpoImage)<{ aspectRatio: number }>`
  width: 100%;
  height: undefined;
  max-width: ${DEFAULT_MAX_WIDTH}px;
  align-self: center;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
`

export const FullWidthImage: FunctionComponent<FullWidthImageProps> = ({ url, accessibilityLabel }) => {
  const [aspectRatio, setAspectRatio] = useState(1)

  useEffect(() => {
    Image.getSize(url, (width, height) => {
      setAspectRatio(width / height)
    })
  }, [url])

  return (
    <ImageContainer
      aspectRatio={aspectRatio || 1}
      source={{ uri: url }}
      contentFit='contain'
      accessibilityLabel={accessibilityLabel}
    />
  )
}
